// extracted by mini-css-extract-plugin
module.exports = {"information":"style_information__1kWLU","wrapper":"style_wrapper__2WWMD","sub_page":"style_sub_page__2uCPu","sections":"style_sections__2qT95"};